function initialState() {
  return {
    banners: [],
  }
}

let state = initialState()

export { initialState, state }
